import { createSelector } from "reselect";

import { getEmails } from "../root";
import { selectSaleTitleByIdLookup } from "../sales";

export const selectEmailAggridData = createSelector(
  [getEmails, selectSaleTitleByIdLookup],
  (emails, saleTitleByIdLookup) =>
    Object.values(emails).map(email => ({
      email,
      id: email.id,
      livestockSale: {
        title: saleTitleByIdLookup[email.livestockSaleId],
      },
    })),
);
